import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog',
  standalone: false,
  templateUrl: './success-dialog.html',
  styleUrl: './success-dialog.less'
})
export class SuccessDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; subtitle: string; icon: string,pageReference?:string },
    private matDialogRef: MatDialogRef<SuccessDialog>
  ) { 
    console.log(data);
  }

  close(): void {
    this.matDialogRef.close();
  }

  addAnotherBrand(){
    this.matDialogRef.close('anotherEntry');
  }
}
